import * as ActionTypes from "./states";
import {
  SESSION_EXPIRED_LOADED,
  SESSION_EXPIRED_UNLOADED,
  SESSION_LOADED,
  SESSION_UNLOADED,
  START_DOWNLOAD
} from "./states";

export const loadAccess = (hrAccess, baAccess,mkbfAccess) => {
  return {
    type: ActionTypes.ACCESS_LOADED,
    hrAccess: hrAccess,
    baAccess: baAccess,
    mkbfAccess: mkbfAccess,
  };
};

export const loadSession = (session)=>{
  return {
    type: ActionTypes.SESSION_LOADED,
    sessionId:session
  }
}

export const unloadSession = ()=>{
  return {
    type: ActionTypes.SESSION_UNLOADED,
    sessionId:""
  }
}

export const loadSessionExpired = (isExpired)=>{
  return {
    type: ActionTypes.SESSION_EXPIRED_LOADED,
    isExpired:isExpired
  }
}

export const unloadAccess = () => {
  return {
    type: ActionTypes.ACCESS_UNLOADED,
    access: {},
  };
};

export const loadLevel = (hrLevel, baLevel,mkbfLevel) => {
  return {
    type: ActionTypes.LEVEL_LOADED,
    hrLevel: hrLevel,
    baLevel: baLevel,
    mkbfLevel:mkbfLevel
  };
};

export const unloadLevel = () => {
  return {
    type: ActionTypes.LEVEL_UNLOADED,
    level: {},
  };
};

export const setLoading = (isLoading,status,titleLabel,subtitleLabel,isDelay) => {

  return {
    type: ActionTypes.SET_LOADING,
    loading: {
      isLoading: isLoading,
      titleLabel: titleLabel ? titleLabel : "Loading...",
      subtitleLabel:subtitleLabel,
      status:status,
      isDelay:isDelay?isDelay:false
    }
  };
};

export const userClick = (isClick) => {
  return {
    type: ActionTypes.CLICK_LOADING,
    value: isClick,
  };
};

export const loadUser = (user) => {
  return {
    type: ActionTypes.USER_LOADED,
    user: user,
  };
};

export const unloadUser = () => {
  return {
    type: ActionTypes.USER_UNLOADED,
    user: {},
  };
};


export const startDownload = (status)=>{
  return {
    type: ActionTypes.START_DOWNLOAD,
    status:status,
  };
}